export default __webpack_public_path__ + "static/media/plan2.8cd3dd45.jpg";